/* Xokool custom scripts */

/* Move the Jotly "Size Chart" app block into the Size variant label (Size: S | Size Chart) */
(function () {
  function moveSizeChart() {
    var btn = document.getElementById('jsc-trigger-button');
    if (!btn) return;
    var block = btn.closest('.shopify-app-block') || btn;
    var legend = document.querySelector('.hdt-product__variant-picker fieldset.is-style-size legend.hdt-product-form__label');
    if (!legend || legend.contains(block)) return;
    block.classList.add('xk-size-chart-inline');
    legend.appendChild(block);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveSizeChart);
  } else {
    moveSizeChart();
  }
})();

/* Loox lives inside the REVIEWS accordion item: it lays itself out while the
   <details> is closed (width 0), so nudge it with a resize event on open */
(function () {
  function bind() {
    document.querySelectorAll('.hdt-product-accordion__item').forEach(function (details) {
      if (!details.querySelector('#looxReviews')) return;
      details.querySelector('summary').addEventListener('click', function () {
        setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 350);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* Clicking the "Guaranteed secure & safe checkout" box scrolls to the
   PAYMENT METHODS accordion tab and opens it */
(function () {
  function bind() {
    var box = document.querySelector('.xk-trust-boxed');
    if (!box) return;
    box.style.cursor = 'pointer';
    box.addEventListener('click', function () {
      var items = document.querySelectorAll('.hdt-product-accordion__item');
      for (var i = 0; i < items.length; i++) {
        var t = items[i].querySelector('.hdt-product-accordion__text');
        if (t && /payment\s*methods/i.test(t.textContent)) {
          if (items[i].hasAttribute('open')) {
            items[i].querySelector('summary').click();
          } else {
            items[i].querySelector('summary').click();
            items[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          break;
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* Clicking the Loox star rating under the product title should open the
   REVIEWS accordion tab and scroll to it. Loox's own click handler (document
   capture) scrolls to the closed <details> position, mid-page — so we listen
   on window capture (fires first) and block it. The product-info column is
   sticky, so a single scrollIntoView undershoots; iterate until it lands. */
(function () {
  window.addEventListener('click', function (e) {
    var rating = e.target.closest ? e.target.closest('.loox-rating') : null;
    if (!rating) return;
    if (rating.closest('.hdt-product-accordion__item')) return; /* rating inside the widget itself */
    var items = document.querySelectorAll('.hdt-product-accordion__item');
    for (var i = 0; i < items.length; i++) {
      if (!items[i].querySelector('#looxReviews')) continue;
      e.preventDefault();
      e.stopImmediatePropagation();
      var item = items[i];
      if (!item.hasAttribute('open')) item.querySelector('summary').click();
      var n = 0;
      var step = function () {
        var t = item.getBoundingClientRect().top;
        if (Math.abs(t) < 30 || n >= 6) return;
        n++;
        item.scrollIntoView({ behavior: 'instant', block: 'start' });
        setTimeout(step, 120);
      };
      setTimeout(step, 450);
      break;
    }
  }, true);
})();
